import { ToolResult } from '../../types/tool.types';
import { ToolContext } from '../tool-context.type';

const VALID_WEATHER_PRESETS = [
	'clear-sunny',
	'overcast',
	'cloudy',
	'twilight',
	'rainy',
	'golden-hour',
	'blue-hour'
] as const;

export async function setWeather(args: any, context: ToolContext): Promise<ToolResult> {
	const { threeInstance, publish } = context;

	const { preset } = args;

	// Validate preset
	if (!preset || typeof preset !== 'string') {
		return {
			success: false,
			error: 'preset parameter is required and must be one of: ' + VALID_WEATHER_PRESETS.join(', ')
		};
	}

	if (!VALID_WEATHER_PRESETS.includes(preset as any)) {
		return {
			success: false,
			error: 'Invalid weather preset. Must be one of: ' + VALID_WEATHER_PRESETS.join(', ')
		};
	}

	// Apply weather preset
	if (!threeInstance) {
		return { success: false, error: 'Three.js instance not available' };
	}

	if (threeInstance.setWeatherPreset) {
		threeInstance.setWeatherPreset(preset);
	} else {
		return { success: false, error: 'Geographic lighting not available in this version' };
	}

	publish('geo_lighting', 'weather_changed', {
		ref: 'weather',
		old: null,
		new: { preset }
	});

	return {
		success: true,
		data: { preset }
	};
}

